import { Platform } from "react-native";
import Color from "../../assets/color/Color";
import StyleSheet from "react-native-media-query";
import { theme } from "../../theme/theme";
// Define your styles
export const { ids, styles } = StyleSheet.create({
  praxisBg: {
    ...Platform.select({
      web: {
        backgroundImage: theme.colors.backgroundGradient,
      }
    }),
  },
  gradientBg: {
    backgroundImage: theme.colors.backgroundGradient,
  },
  scrollArea: {
    display: "flex",
    ...Platform.select({
      ios: {
        display: "flex",
        flex: 1,
      },
      android: {
        display: "flex",
        flex: 1,
      },
    }),
  },
  loader: {
    display: "flex",
    flex: 1,
    backgroundColor: theme.colors.black + 50,
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    height: "110%",
  },
  container: {
    display: "flex",
    left: 0,
    right: 0,
    bottom: 0,
    marginLeft: "auto",
    marginRight: "auto",
    maxWidth: "100%",
    width: "100%",
    "@media (min-width: 700px)": {
      maxWidth: 1180,
    },
    ...Platform.select({
      ios: {
        display: "flex",
        flex: 1,
      },
      android: {
        display: "flex",
        flex: 1,
      },
      web: {
        top: 70,
        position: "static",
      },
    }),
  },
  registerContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    paddingTop: 50,
    paddingBottom: 50,
    ...Platform.select({
      ios: {
        display: "flex",
        flex: 1,
        height: "100%",
      },
      android: {
        display: "flex",
        flex: 1,
      },
      web: {
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        position: "absolute",
      },
    }),
  },
  loginLink: {
    color: theme.colors.white,
    fontWeight: "600",
    ...Platform.select({
      ios: {
        textDecorationLine: "underline",
        textDecorationStyle: "solid",
        textDecorationColor: theme.colors.white,
      },
      android: {
        textDecorationLine: "underline",
        textDecorationStyle: "solid",
        textDecorationColor: theme.colors.white,
      },
      web: {
        textDecoration: "underline",
      },
    }),
  },
  loginHere: {
    display: "flex",
    alignItems: "center",
    fontSize: 16,
    marginTop: 24,
  },
  whiteTextSmall: {
    fontSize: theme.fontsize.cs,
    textAlign: "left",
    fontFamily: theme.fontFamily.robotoRegular,
    color: theme.colors.white,
    fontWeight: "400",
  },
  loginSuccess: {
    display: "flex",
    alignItems: "center",
    maxWidth: 600,
    ...Platform.select({
      ios: {
        "@media (min-width: 200px)": {
          paddingLeft: 16,
          paddingRight: 16,
        },
        "@media (min-width: 600px)": {
          paddingLeft: 0,
          paddingRight: 0,
        },
      },
      android: {
        "@media (min-width: 200px)": {
          paddingLeft: 16,
          paddingRight: 16,
        },
        "@media (min-width: 600px)": {
          paddingLeft: 0,
          paddingRight: 0,
        },
      },
      web: {
        paddingLeft: 16,
        paddingRight: 16,
        width: "100%",
      },
    }),
  },
  logoBlock: {
    marginBottom: 24,
  },
  Logo: {
    width: 200,
    height: 100,
    display: "flex",
    resizeMode: "contain",
    "@media (min-width: 700px)": {
      width: 250,
      height: 120,
    },
  },
  verifiedIcon: {
    width: 182,
    height: 182,
  },
  heading: {
    width: "100%",
    ...Platform.select({
      ios: {
        marginBottom: 12,
        marginTop: 20,
      },
      android: {
        marginBottom: 8,
        marginTop: 20,
      },
      web: {
        marginBottom: 24,
        marginTop: 40,
      },
    }),
  },
  inRight: {
    display: "flex",
    textAlign: "left",
  },
  headingText: {
    fontFamily: theme.fontFamily.robotoSlabBold,
    fontSize: theme.fontsize.xlg,
    letterSpacing: 0,
    textAlign: "left",
    color: theme.colors.white,
  },
  verifiedBlock: {
    marginTop: 16,
    marginBottom: 24,
  },
  whiteText: {
    fontFamily: theme.fontFamily.robotoRegular,
    color: theme.colors.white,
  },
  textCenter: {
    textAlign: "center",
  },
  submitButton: {
    minWidth: "100%",
    backgroundColor: theme.colors.button.primary,
    padding: 12,
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    borderRadius: 10,
    marginTop: 24,
    marginBottom: 24,
    fontWeight: "600",
  },
  btnText: {
    fontFamily: theme.fontFamily.robotoBold,
    fontWeight: theme.fontweight.medium,
    color: theme.colors.white,
    fontSize: theme.fontsize.md,
  },
  textBold: {
    fontFamily: theme.fontFamily.robotoBold,
    fontWeight:theme.fontweight.bold,
    color: theme.colors.white,
    fontSize: theme.fontsize.cs,
  },
  navigation: {
    elevation: 999,
  },
});
